import {SIZES} from './pagination-stripe/constants';

export const setMaxPaginationSize = (size: number): Array<number> => {
    const sizes = SIZES.filter((s: number) => s <= size);

    return sizes.length ? sizes : [SIZES[0]];
};
